export const iconFontAwesomeMoneyHandHoldingDollar = (
	<i className="fa-solid fa-hand-holding-dollar"></i>
);
